import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { dropboxService } from 'src/services/dropbox';
import CloudStorageInput from '../CloudStorageInput';
import dropboxIcon from '../../../assets/images/dropbox.svg';

function DropboxInput({ onFileLoaded, disabled, hasError }) {
  const serviceAdapter = useMemo(() => ({
    isValidUrl: (url) => dropboxService.isValidDropboxUrl(url),
    importFromUrl: (url) => dropboxService.importFromUrl(url),
  }), []);

  return (
    <CloudStorageInput
      service={serviceAdapter}
      icon={dropboxIcon}
      iconAlt="Dropbox"
      label="Cole o link de um CSV do Dropbox"
      errorMessage="Erro ao carregar arquivo do Dropbox."
      onFileLoaded={onFileLoaded}
      disabled={disabled}
      hasError={hasError}
    />
  );
}

DropboxInput.propTypes = {
  onFileLoaded: PropTypes.func,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
};

DropboxInput.defaultProps = {
  onFileLoaded: null,
  disabled: false,
  hasError: false,
};

export default DropboxInput;
